import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import AppTheme from './components/AppTheme';

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <AppTheme />
    </LocalizationProvider>
  </React.StrictMode>
);
